import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ContractService } from '../../../_services';
import { ContractIfrsBase } from "./base/contract-ifrs.base";


@Component({
	selector: 'f-index-calculation-information',
	template: require('./f-index-calculation-information.component.html'),
	encapsulation: ViewEncapsulation.None
})
export class IndexCalculationInformationComponent
	extends ContractIfrsBase implements OnInit {

	constructor(contractService: ContractService) { super(contractService); }

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/ifrs/f-index-calculation-information.component.ts